import { assertUnreachable } from './assertUnreachable';
import { CardStrapi } from '@/strapi-types';
import { contentTypeMap, ContentTypes } from './get-content-type';

/**
 * It takes a post and returns the router path to that post
 * @param locale
 * @param type
 * @param card
 * @returns The path to the post.
 */
export function getCardPath(
  locale: string,
  type: ContentTypes,
  card: CardStrapi,
) {
  const { singular, plural } = contentTypeMap[type];
  if (!singular) {
    return assertUnreachable(type as never);
  }
  // this case is for sake that we have route folder 'news' instead of 'new' to be refactored in future !
  if (singular === 'new') {
    return `/${locale}/${plural}/${card.slug}/`;
  }
  return `/${locale}/${singular}/${card.slug}/`;
}
